export const PANEL_ON_OPEN_EVENT_NAME = 'mntdPanelOnOpen';
export const PANEL_ON_CLOSE_EVENT_NAME = 'mntdPanelOnClose';
/** To be run when content inside the panel is resized */
export const PANEL_ON_RESIZE_EVENT_NAME = 'mntdPanelOnResize';
